import React, { useState } from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { Button } from "@my-scoot/component-library-legacy";
import ShareRecording from "schedule-v2/components/ShareRecording/ShareRecording";
import ExlyLoader from "ui/modules/ExlyLoader";
import { useRecordingSettingsModal } from "./hooks/useRecordingSettingsModal";
import { RECORDING_SETTINGS_MODAL_CONSTANTS } from "../../constants/ManageRecordings.constant";

/**
 * RecordingSettingsModal Component
 *
 * Renders a secondary "Recording settings" button that opens an ExlyModal to allow creators
 * to configure recording controls (Session recording, Auto-package recordings into course,
 * and customer access controls).
 *
 * @param {Object} props
 * @param {Object} [props.formProps] - Fallback form state passed from parent table
 * @param {boolean} props.isDesktop - Media query check for desktop responsive layout
 * @param {string} [props.listingUuid] - Active listing/offering UUID
 */
export const RecordingSettingsModal = (props) => {
  const { formProps, isDesktop, listingUuid } = props;
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  const {
    isSaving,
    isLoadingDetails,
    shareRecordingRef,
    handleSaveDetails,
    isAutoRecordableVal,
    mapToCourseVal,
    recordingAccessibilityVal,
    addressTypeVal,
    typeVal,
  } = useRecordingSettingsModal({
    formProps,
    listingUuid,
    openModal,
    onClose: handleClose,
  });

  return (
    <>
      <Button
        color="secondary"
        size={isDesktop ? "medium" : "small"}
        onClick={handleOpen}
      >
        {RECORDING_SETTINGS_MODAL_CONSTANTS.BUTTON_TITLE}
      </Button>

      {openModal && (
        <ExlyModal
          open={openModal}
          onClose={handleClose}
          title={RECORDING_SETTINGS_MODAL_CONSTANTS.MODAL_TITLE}
          showSecondaryBtn={true}
          secondaryBtnText={RECORDING_SETTINGS_MODAL_CONSTANTS.CANCEL_BTN_TEXT}
          onSecondaryBtnClick={handleClose}
          primaryBtnText={RECORDING_SETTINGS_MODAL_CONSTANTS.SAVE_BTN_TEXT}
          onPrimaryBtnClick={handleSaveDetails}
          primaryBtnProps={{
            loading: isSaving,
            disabled: isSaving || isLoadingDetails,
          }}
          desktopModalWidth={RECORDING_SETTINGS_MODAL_CONSTANTS.MODAL_WIDTH}
        >
          <div className="tw-py-2">
            {isLoadingDetails ? (
              <ExlyLoader />
            ) : (
              <ShareRecording
                ref={shareRecordingRef}
                showAutoPackage={true}
                isAutoRecordable={isAutoRecordableVal}
                mapToCourse={mapToCourseVal}
                recordingAccessControl={recordingAccessibilityVal}
                addressType={addressTypeVal}
                type={typeVal}
                isAccessControlEditable={true}
                {...formProps}
              />
            )}
          </div>
        </ExlyModal>
      )}
    </>
  );
};
